import React from 'react';
import {FormattedMessage} from 'react-intl';


class ReportSummaryErrorHandler extends React.Component {
  constructor(props) {
    super(props);
    this.state = {error: false};
  }
  componentDidCatch(error) {
    console.log(error);
    this.setState({error: true});
  }
  render() {

    if (this.state.error || this.props.error) {
      return <div className="summary-container">
        <h2><FormattedMessage id="reports.report.summary"/></h2>
        <br/>
        <span><FormattedMessage id="reports.reveal.report.summary"/></span>
        <label className="report-error"><FormattedMessage id='report.could.not.load' /></label>
      </div>;
    }
    return this.props.children;
  }
}

export default ReportSummaryErrorHandler;
